import React from "react";
import styled from "@emotion/styled";

import land_register_ticket_ico from "@src/assets/landRegister/land_register_ticket_ico.png";

import { TICKET_TYPE } from "@src/components/deungi/common/enum";
import { useFindOneTicketCount } from "@src/hooks/deungi/useTicketCount";
const LandRegisterTicketBox = () => {
    const { data: ticketCount } = useFindOneTicketCount(TICKET_TYPE.LAND_REGISTER_TICKET);

    return (
        <>
            <Container>
                <div>
                    <div className={"ticketItem"}>
                        <img src={land_register_ticket_ico} />
                        <h3>
                            실시간 토지•임야대장 열람권
                            <label>{ticketCount?.curHaveCnt || 0}장</label>
                        </h3>
                    </div>
                </div>
            </Container>
            <div className="backDiv" />
        </>
    );
};

const Container = styled.div`
    position: fixed;
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;
    background: #fff;
    box-sizing: border-box;
    width: 100%;
    top: 55px;
    gap: 10px;
    padding: 0 14px 14px;
    z-index: 2;

    & > div {
        display: flex;
        align-items: center;
        width: 100%;
        gap: 10px;
    }

    .ticketItem {
        flex: 1;
        display: flex;
        flex-wrap: wrap;
        border-radius: 8px;
        padding: 12px 8px;
        transition: all 0.2s ease;
        background: #f6faff;

        & > h3 {
            color: #0c002c;
            font-size: 13px;
            font-weight: 500;
            line-height: 1.4;
            min-width: 80px;
            width: max-content;
            text-align: center;
            margin: 4px auto 0;

            & > label {
                display: block;
                font-size: 14px;
                font-weight: 700;
                color: #0047ff;
                text-align: center;
            }
        }
        & > img {
            width: 38px;
            height: 38px;
            background: #fff;
            border-radius: 4px;
            padding: 6px;
            margin: auto;
        }
    }
`;

export default LandRegisterTicketBox;
